import { Distributor, DistributorDetails, DistributorGroups } from "src/app/fees-management/distributor.const";
import { FEES_MANAGEMENT_LABELS } from "src/app/fees-management/labels.const";
import { StaticDataHasApproval, TableCols, TableColTypes } from "../interfaces/static-data";
import { LegalEntity } from "./legal-entity.const";

const labels = FEES_MANAGEMENT_LABELS.distributor;

export const DISTRIBUTORS: TableCols<TableColTypes, Distributor & DistributorDetails & StaticDataHasApproval>[] = [
    {
        key: 'name',
        displayValue: labels.name,
        valueGetter: (value: any) => value?.data?.distributorDetails?.name ?? value?.data?.name,

    },
    {
        key: 'distributorGroup',
        displayValue: labels.distributorGroup,
        valueGetter: (value: any) => (value?.data?.distributorGroup as any as DistributorGroups)?.name,
    },
    {
        key: 'country', displayValue: labels.country,
        valueGetter: (value: any) => value?.data?.distributorDetails?.country ?? value?.data?.country,
    },
    {
        key: 'legalEntity', displayValue: labels.legalEntity,
        valueGetter: (value: any) => (value?.data?.legalEntity as any as LegalEntity)?.name,
    },
    {
        key: 'workflowStatus',
        displayValue: labels.workflowStatus,
        valueGetter: (value: any) => value?.data?.distributorDetails?.workflowStatus ?? value?.data?.workflowStatus,
    },
    {
      key: 'workflowStatus',
      displayValue: 'Workflow Status',
      hideOnForm: true
    },
    {
      key: 'lastUpdatedBy',
      displayValue: 'Last Updated By',
      hideOnForm: true
    },
    {
      key: 'updatedOn',
      displayValue: 'Updated On',
      hideOnForm: true
    },
    {
      key: 'deletedAt',
      displayValue: 'Deleted On',
      hideOnForm: true
    },
];
